import { Box, Flex, IconButton, Drawer } from '@chakra-ui/react';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext.jsx';
import Sidebar from './Sidebar.jsx';

const Layout = ({ children }) => {
  const { logout } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <Flex minH="100vh">
      <Box display={{ base: 'none', md: 'block' }}>
        <Sidebar onLogout={handleLogout} isLoading={isLoggingOut} />
      </Box>
      <Drawer.Root
        open={drawerOpen}
        placement="left"
        onOpenChange={(details) => setDrawerOpen(details.open)}
      >
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content>
            <Drawer.Body p={0}>
              <Sidebar onLogout={handleLogout} isLoading={isLoggingOut} />
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Drawer.Root>
      <Box flex="1" p={{ base: 4, md: 8 }}>
        <IconButton
          icon={<span>☰</span>}
          aria-label="Open menu"
          display={{ base: 'inline-flex', md: 'none' }}
          mb={4}
          onClick={() => setDrawerOpen(true)}
        />
        {children}
      </Box>
    </Flex>
  );
};

export default Layout;
